// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pageAlign{\n  float:right;\n}\n.pageInfodata {\n    position: absolute;\n    top: -18px;\n    right: 0;\n    font-size: var(--font16);\n    color: #808495;\n    line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
